var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DailyBeetNavBar'),_c('VContent',{staticClass:"view-content"},[_c('VContainer',{attrs:{"fluid":"","pa-0":""}},[_c('BaseThemeComponent',{attrs:{"name":"GlobalNotice"}}),_vm._t("default")],2)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }